<template>
  <div class="page-content">
    <div class="administrador-heading">
      <h5>{{ $t("lang.location_form.page_title") }}</h5>
    </div>
    <div class="centros-formbg" style="padding-bottom: 0px">
      <a href="#areas">
        <h6>{{ $t("lang.location_form.label_view_areas") }}</h6>
      </a>
      <h6>{{ $t("lang.location_form.form_title") }}</h6>
      <div class="centros-form">
        <div v-if="errors.length && !success.show">
          <b>{{ $t("lang.admin.area_form.error_list_title") }}</b>
          <div class="alert alert-danger" role="alert">
            <ul style="list-style-type: circle; margin: 10px">
              <li v-for="(error, index) in errors" :key="index">{{ error }}</li>
            </ul>
          </div>
        </div>
        <div v-show="success.show">
          <div class="alert alert-success" role="alert">
            {{ success.message }}
          </div>
        </div>
        <form v-if="input">
          <div class="form-row d-flex align-items-end">
            <div class="form-row align-items-center d-flex flex-row col-md-6">
              <div
                class="form-group col-md-6"
                @click="$refs.filePicker.click()"
              >
                <div class="tempPickerDiv">
                  <label for="logo">{{
                    $t("lang.location_form.labels.logo")
                  }}</label>
                  <img
                    style="height: 120px"
                    :src="input.logo"
                    v-if="input.logo"
                    class="img img-fluid"
                  />
                  <input
                    ref="filePicker"
                    @change="filePicked"
                    type="file"
                    style="display: none"
                    accept="image/*"
                  />
                </div>
              </div>
              <div
                class="select-box col-md-6 p-0"
                style="margin-top: 3.6rem !important"
              >
                <v-select
                  :items="brands"
                  item-text="description"
                  v-model="input.brand_id"
                  item-value="id"
                  :label="$t('lang.location_form.labels.brand')"
                  outlined
                ></v-select>
              </div>
            </div>
            <div class="col-md-6">
              <v-text-field
                :label="$t('lang.location_form.labels.name')"
                outlined
                v-model="input.description"
              ></v-text-field>
            </div>
          </div>
          <div class="form-row">
            <div class="col-md-6">
              <v-text-field
                :label="$t('lang.location_form.labels.phone')"
                outlined
                v-model="input.phone_name"
              ></v-text-field>
            </div>
            <div class="col-md-6">
              <v-text-field
                :label="$t('lang.location_form.labels.email')"
                outlined
                type="email"
                v-model="input.email"
              ></v-text-field>
            </div>
          </div>
          <div class="form-row">
            <div class="col-md-6">
              <v-text-field
                :label="$t('lang.location_form.labels.street_name')"
                outlined
                v-model="input.street_name"
              ></v-text-field>
            </div>
            <div class="col-md-6">
              <v-text-field
                :label="$t('lang.location_form.labels.street_num')"
                outlined
                v-model="input.street_num"
              ></v-text-field>
            </div>
          </div>
          <div class="form-row">
            <div class="col-md-4">
              <v-text-field
                :label="$t('lang.location_form.labels.city')"
                outlined
                v-model="input.city"
              ></v-text-field>
            </div>
            <div class="col-md-4">
              <v-text-field
                :label="$t('lang.location_form.labels.cp')"
                outlined
                v-model="input.cp"
              ></v-text-field>
            </div>
            <div class="select-box col-md-4">
              <v-select
                :items="countries"
                item-text="country"
                v-model="input.country"
                item-value="country"
                :label="$t('lang.location_form.labels.country')"
                outlined
              ></v-select>
            </div>
          </div>
          <div class="form-row">
            <div class="col-md-12">
              <v-textarea
                :label="$t('lang.location_form.labels.observations')"
                outlined
                v-model="input.observations"
              ></v-textarea>
            </div>
          </div>
          <div class="form-row">
            <div class="mb-0 col-md-12">
              <v-btn text rounded type="reset" @click="$router.back()">{{
                $t("lang.location_form.btn_cancel")
              }}</v-btn>
              <bx-btn color="primary" @click="submitForm">{{
                $t("lang.location_form.btn_done")
              }}</bx-btn>
            </div>
          </div>
        </form>
      </div>
    </div>
    <div class="page-main-content mx-md-3" id="areas">
      <div class="container-fluid">
        <div class="row">
          <bx-box
            :title="totalAreas + ' ' + $t('lang.admin.list_of_areas')"
            color="white"
            no-padding
            :loading="shouldLoading"
            class="col-12"
          >
            <template v-slot:default>
              <skeleton-table :columns="4" v-if="shouldLoading" />

              <bx-table
                :data="data"
                :columns="columns"
                paginated
                v-if="!shouldLoading"
                :currentPage="page"
                :perPage="itemsPerPage"
                backendPagination
                :total="totalAreas"
                @update:currentPage="updatePage"
              >
                <template slot-scope="props">
                  <bx-table-column centered>{{
                    props.row.stock
                  }}</bx-table-column>
                  <bx-table-column centered>{{
                    props.row.description
                  }}</bx-table-column>
                  <bx-table-column centered>
                    <router-link
                      :to="`/administrador/locations/${props.row.location}/edit`"
                      class="bx-link bx-link-bold"
                      >{{ props.row.location_description }}</router-link
                    >
                  </bx-table-column>
                  <bx-table-column centered>
                    <router-link
                      :to="`/administrador/areas/${props.row.id}/edit`"
                      class="bx-link bx-link-bold"
                      >Edit</router-link
                    >
                  </bx-table-column>
                </template>
              </bx-table>
            </template>
          </bx-box>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "AddLocationForm",
  props: ["id"],
  data() {
    return {
      input: null,
      errors: [],
      countries: [],
      brands: [],
      success: {
        show: false,
        message: this.$t("lang.location_form.success_edit")
      },
      errorLabels: {
        description: this.$t("lang.location_form.errors.description"),
        street_name: this.$t("lang.location_form.errors.street_name"),
        street_number: this.$t("lang.location_form.errors.street_number"),
        city: this.$t("lang.location_form.errors.city"),
        postal_code: this.$t("lang.location_form.errors.postal_code"),
        country: this.$t("lang.location_form.errors.country"),
        notFound: this.$t("lang.admin.area_form.errors.not_found"),
        failed: this.$t("lang.location_form.errors.failed")
      },

      // tabledata
      shouldLoading: true,
      columns: [],
      data: [],
      totalAreas: 0,
      itemsPerPage: process.env.VUE_APP_ITEMS_PER_PAGE,
      page: 1
    };
  },
  async mounted() {
    this.getData();
    try {
      this.countries = await this.$api.common.getCountries();
      let location = await this.$api.location.getLocationById(this.id);
      this.brands = await this.$api.location.getBrands();
      this.input = {
        id: location.id,
        description: location.description,
        brand_id: location.brand,
        street_name: location.address.street_name,
        street_num: location.address.street_num,
        floor: "1",
        city: location.address.city,
        postal_code: location.address.postal_code,
        country: location.address.country
      };
    } catch (error) {
      console.log(error);
      this.errors.push(this.errorLabels.notFound);
    }
  },
  methods: {
    async submitForm() {
      let input = Object.assign({}, this.input);

      if (this.validate()) {
        delete input.logo;
        delete input.observations;
        delete input.email;
        delete input.phone_name;

        input.postal_code = parseInt(input.postal_code);
        input.street_num = parseInt(input.street_num);

        try {
          let response = await this.$api.location.update(input);
          console.log(response);

          this.success.show = true;
        } catch (error) {
          this.errors.push(this.errorLabels.failed);
        }
      }
    },
    validate() {
      this.errors = [];
      let error = false;
      this.success.show = false;

      if (!this.input.description) {
        error = true;
        this.errors.push(this.errorLabels.description);
      }

      if (!this.input.street_name) {
        error = true;
        this.errors.push(this.errorLabels.street_name);
      }

      if (!this.input.street_num) {
        error = true;
        this.errors.push(this.errorLabels.street_number);
      }

      if (!this.input.city) {
        error = true;
        this.errors.push(this.errorLabels.city);
      }

      if (!this.input.postal_code) {
        error = true;
        this.errors.push(this.errorLabels.postal_code);
      }

      if (!this.input.country) {
        error = true;
        this.errors.push(this.errorLabels.country);
      }

      if (!this.input.brand_id) {
        error = true;
        this.errors.push(this.errorLabels.brand);
      }

      if (error) {
        return false;
      }

      return true;
    },
    filePicked(files) {
      let self = this;
      if (files && files.srcElement.files) {
        var reader = new FileReader();

        reader.onload = function(e) {
          self.input.logo = e.target.result;
        };

        reader.readAsDataURL(files.srcElement.files[0]);
      }
    },
    updatePage(p) {
      this.page = p;
      this.getData();
    },
    async getData() {
      let areas = await this.$api.area.list({
        offset: (this.page - 1) * this.itemsPerPage,
        limit: this.itemsPerPage,
        location: this.id
      });
      this.data = areas.results;
      this.totalAreas = areas.count;
      this.columns = [
        {
          field: "stock",
          label: this.$t("lang.admin.label_stock"),
          centered: true
        },
        {
          field: "description",
          label: this.$t("lang.admin.label_description"),
          centered: true
        },
        {
          field: "location_description",
          label: this.$t("lang.admin.label_location"),
          centered: true
        },
        {
          field: "",
          label: this.$t("lang.admin.label_action"),
          centered: true
        }
      ];

      this.shouldLoading = false;
    }
  }
};
</script>

<style>
.tempPickerDiv {
  height: 120px;
  width: 100%;
  border: 1px solid #000;
  border-radius: 10px;
  cursor: pointer;
}
</style>
